import { trackChristmasMarketPurchase } from '~/modules/ChristmasMarketAnalytics.js'

const STORAGE_PREFIX = 'xmas_purchase_tracked:'

export function initChristmasMarketPurchaseTracking(root = document) {
  if (!root || typeof root.querySelectorAll !== 'function') {
    return
  }

  root.querySelectorAll('[data-xmas-purchase-tracking]').forEach((node) => {
    if (node.dataset.xmasPurchaseTrackingInitialized === 'true') {
      return
    }

    node.dataset.xmasPurchaseTrackingInitialized = 'true'
    const track = () => trackPurchase(node)
    if (!track()) {
      document.addEventListener('termsfeed.consentAccepted', track, { once: true })
    }
  })
}

function trackPurchase(node) {
  const orderId = node.dataset.xmasPurchaseOrderId
  if (!orderId || purchaseWasTracked(orderId)) {
    return true
  }

  const result = trackChristmasMarketPurchase({
    area_tier: node.dataset.xmasPurchaseAreaTier,
    event_days: node.dataset.xmasPurchaseEventDays,
    net_price: node.dataset.xmasPurchaseNetPrice,
    pricing_version: node.dataset.xmasPurchasePricingVersion
  })
  if (result === false) {
    return false
  }

  rememberPurchase(orderId)
  return true
}

function purchaseWasTracked(orderId) {
  try {
    return window.sessionStorage.getItem(`${STORAGE_PREFIX}${orderId}`) === '1'
  } catch (_error) {
    return false
  }
}

function rememberPurchase(orderId) {
  try {
    window.sessionStorage.setItem(`${STORAGE_PREFIX}${orderId}`, '1')
  } catch (_error) {
    // Analytics must never interrupt the payment status page.
  }
}
